<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7812 15.6289C17.0547 15.9023 17.0547 16.3125 16.7812 16.5586C16.6719 16.6953 16.5078 16.75 16.3438 16.75C16.1523 16.75 15.9883 16.6953 15.8516 16.5586L12.1875 12.8945C11.2031 13.6875 9.97266 14.125 8.66016 14.125C5.54297 14.125 3 11.582 3 8.4375C3 5.32031 5.51562 2.75 8.66016 2.75C11.7773 2.75 14.3477 5.32031 14.3477 8.4375C14.3477 9.77734 13.9102 11.0078 13.1172 11.9648L16.7812 15.6289ZM4.3125 8.4375C4.3125 10.8711 6.25391 12.8125 8.6875 12.8125C11.0938 12.8125 13.0625 10.8711 13.0625 8.4375C13.0625 6.03125 11.0938 4.0625 8.6875 4.0625C6.25391 4.0625 4.3125 6.03125 4.3125 8.4375Z"
      fill="currentColor"
    />
  </svg>
</template>
